<template>
  <div  >
    <a-form-model ref="form" :model="model" :rules="validatorRules">

      <a-row style="width: 100%;border: 2px">
        <a-col :span="13">
          <a-form-model-item :label="language['user.column.Avatar']" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <j-image-upload class="avatar-uploader" :text="language['common.uploadButton']" v-model="model.avatar" :upload-source="`platform`" :disabled="disabled"></j-image-upload>
          </a-form-model-item>
        </a-col>
        <div >
<!--        <a-col :span="12">
          <a-form-model-item :label="language['user.column.Avatar']" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <j-image-upload class="avatar-uploader" :text="language['common.uploadButton']" v-model="model.avatar" :upload-source="`platform`" ></j-image-upload>
          </a-form-model-item>
        </a-col>-->
        <a-col :span="12">
          <a-form-model-item prop="realname" :label="this.language['portal.front.realname']" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input  v-model="model.realname" :disabled="disabled" :maxLength="maxLength"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="userType === 'nonemployee'">
          <a-form-model-item :label="this.language['user.column.userAccount']" prop="username"  :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="model.username"  type="text" :disabled="disabled" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="userType === 'employee'">
          <a-form-model-item :label="this.language['column.jobNumber']" prop="workNo"  :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="model.workNo"  type="text" :disabled="disabled" />
          </a-form-model-item>
        </a-col>
        </div>
<!--        <a-col :span="24" v-if="userType === 'employee'">
          <a-form-model-item :label="language['employee.column.englishName']" :labelCol="labelCol" :wrapperCol="wrapperCol"  >
            <a-input v-model="model.englishName" type="text"  :maxLength="40" />
          </a-form-model-item>
        </a-col>-->
        <div >
        <a-col :span="12">
          <a-form-model-item :label="this.language['column.gender']"  :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sex">
            <JDictSelectTag :type="'radio'"   v-model="model.sex" dictCode="sex" style="size: 100px" :disabled="disabled" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="userType === 'employee'">
          <a-form-model-item :label="language['user.column.birthday']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="joinDate">
            <a-input v-model="model.birthday" type="text"  :maxLength="maxLength" :disabled="disabled"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="userType === 'employee'">
          <a-form-model-item :label="this.language['basedata.country']"  :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="model.country" type="text"  :maxLength="maxLength" :disabled="disabled"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="userType === 'employee'">
          <a-form-model-item :label="this.language['portal.front.factory']"  :labelCol="labelCol" :wrapperCol="wrapperCol" prop="siteCode">
            <a-input v-model="model.factoryName" type="text"  :maxLength="maxLength" :disabled="disabled"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="userType === 'employee'">
          <a-form-model-item :label="this.language['basedata.suborg']"  :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="model.suborg" type="text"  :maxLength="maxLength" :disabled="disabled"/>
          </a-form-model-item>
        </a-col>




          <a-col :span="12" v-if="userType === 'employee'">
            <a-form-model-item :label="language['businessGroupName']"  :labelCol="labelCol" :wrapperCol="wrapperCol" prop="bg" >
              <a-input v-model="model.bg" type="text"  :disabled="disabled"  />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="userType === 'employee'">
            <a-form-model-item :label="language['businessUnitName']"  :labelCol="labelCol" :wrapperCol="wrapperCol" prop="bu">
              <a-input v-model="model.bu" type="text"  :disabled="disabled"  />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="userType === 'employee'">
            <a-form-model-item  :label="language['portal.personalOrgCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="departName">
              <a-input v-model="model.departName" type="text"  :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="userType === 'employee'">
            <a-form-model-item :label="this.language['PlatForm.employee.columns.empClass']"  :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input v-model="model.empClass" type="text"   :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="userType === 'employee'">
            <a-form-model-item :label="this.language['cs.person.jobname']"  :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input v-model="model.jobTitle" type="text"   :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="userType === 'employee'">
            <a-form-model-item :label="this.language['legalperson.name']"  :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input v-model="model.companyName" type="text"  :disabled="disabled"  />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="userType === 'employee'">
            <a-form-model-item :label="this.language['emp.content.legalperson_withOutsourcing']"  :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input v-model="deliveryCompanyName" type="text"  :disabled="disabled"  />
            </a-form-model-item>
          </a-col>

          <a-col :span="12" v-if="userType === 'employee'">
            <a-form-model-item :label="this.language['PlatForm.employee.columns.costCode']"  :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input v-model="model.costCode" type="text"  :disabled="disabled"  />
            </a-form-model-item>
          </a-col>

          <a-col :span="12" v-if="userType === 'nonemployee'">
            <a-form-model-item :label="this.language['common.company']"  :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input v-model="model.companyName" type="text" :disabled="disabled"   />
            </a-form-model-item>
          </a-col>

       </div>

        <a-col :span="12" >
          <a-form-model-item  :label="language['column.Landline']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="1">
            <a-input v-model="model.telephone" type="text"  :maxLength="maxLength" :disabled="disabled" />
          </a-form-model-item>
        </a-col>

        <a-col :span="12" >
          <a-form-model-item :label="this.language['column.mailbox']"  :labelCol="labelCol" :wrapperCol="wrapperCol" prop="email" v-if="userType === 'employee'">
            <a-input v-model="model.email" type="text"   :maxLength="maxLength" :disabled="disabled" />
          </a-form-model-item>
          <a-form-model-item :label="this.language['column.mailbox']"  :labelCol="labelCol" :wrapperCol="wrapperCol" v-else>
            <a-input v-model="model.email" type="text"   :maxLength="maxLength" :disabled="disabled" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12" >
          <a-form-model-item  :label="this.language['column.cellphoneNumber']"  prop="phone"  :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="model.phone" type="text" autocomplete="false" :maxLength="20" :disabled="disabled" > <!-- :disabled="userType === 'nonemployee'"-->
              <a-icon slot="prefix" type="phone" :style="{ color: 'rgba(0,0,0,.25)'}"/>
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="userType === 'employee'">
          <a-form-model-item :label="this.language['portal.front.join.date']" :labelCol="labelCol" :wrapperCol="wrapperCol"  prop="joinDate">
            <a-input v-model="model.joinDate" type="text"  :maxLength="maxLength" :disabled="disabled"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="userType === 'employee'">
          <a-form-model-item :label="this.language['labor.laborEmploymentStatus']"  :labelCol="labelCol" :wrapperCol="wrapperCol" >
            <a-input v-model="model.jobStatus" type="text"  :disabled="disabled"  />
          </a-form-model-item>
        </a-col>
<!--        <a-col :span="24" v-if="userType === 'employee'">
          <a-form-model-item :label="language['PlatForm.employee.columns.address']" :labelCol="labelCol" :wrapperCol="wrapperCol"  >
            <a-input v-model="model.address" type="text"  :maxLength="100" />
          </a-form-model-item>
        </a-col>-->

<!--        <a-col :span="24">-->
<!--          <a-form-model-item  :label="this.language['portal.front.verificationCode']"  prop="captcha"  :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--            <a-input v-model="model.captcha" type="text" autocomplete="false" :placeholder="this.language['system.verificationCode']" style="width: 200px;margin-right: 20px">-->
<!--              <a-icon slot="prefix" type="code" :style="{ color: 'rgba(0,0,0,.25)'}"/>-->
<!--            </a-input>-->
<!--            <a-button-->
<!--              tabindex="-1"-->
<!--              size="default"-->
<!--              :disabled="state.smsSendBtn"-->
<!--              @click.stop.prevent="getCaptcha"-->
<!--              v-text="!state.smsSendBtn && this.language['portal.front.getCode'] || (state.time+' s')"></a-button>-->
<!--          </a-form-model-item>-->
<!--        </a-col>-->

<!--        <a-col :span="24">
          <a-form-item style="margin-top:24px;text-align:center">
            <a-button size="large" type="primary"  htmlType="submit"  class="login-button"  :loading="loginBtn"  @click.stop.prevent="handleSubmit" :disabled="loginBtn">{{this.language['common.submitButton']}}</a-button>
          </a-form-item>

        </a-col>-->


      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import {mixinDevice} from '@/utils/mixin.js'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import {getAction, postAction,putAction} from '@/api/manage'
import moment from 'moment'
import {mapActions} from 'vuex'
//import SelectDepart from '@/views/portal/user/register/SelectDepart'
//import {commitUserInfo, gotoIndex, gotoIndexOrReload, timeOutReload} from "../../../../utils/portal/config";
import store from "@/store"
export default {
  name: "UserInfo",
  components: {},
  mixins: [mixinDevice],
  props:["fatcherMethod"],
  data() {
    return {
      description: '用户信息',
      loginBtn:false,
      nationalityRegionList:[],
      show: true,
      employeeDisable:true,
      model: {},
      maxLength:40,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      dateFormat:"YYYY-MM-DD",
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
      },
      registerBtn: false,
      disabled:"disabled",
      url: {
        checkUsernameAndWorkNoDuplicate: '/sys/sysUserApply/checkUsernameAndWorkNoDuplicate',
      },
      userType: "",
      deliveryCompanyName: "",
    }
  },
  created() {

  },
  computed: {
    language() {
      return this.$store.getters.language
    },validatorRules() {
      if (this.language) {
        return {
      /*sex: [
        {required: false, message:this.language['column.pleaseChoose']+this.language['column.gender']+"!"}
      ],
      joinDate: [
        {required: false, message:this.language['column.pleaseChoose']+this.language['portal.front.join.date']+"!"}
      ],
      selecteddeparts: [
        {required: false, message:this.language['column.pleaseChoose']+this.language['businessGroupName']+"!"}
      ],
       bg: [
        {required: false},
        {min: 2, max: 100, message: this.language['common.lengthRange']+' 2 '+this.language['common.to']+' 100 '+this.language['common.character'], trigger: 'blur'}

      ],
      bu: [
            {required: false},
            {min: 2, max: 100, message: this.language['common.lengthRange']+' 2 '+this.language['common.to']+' 100 '+this.language['common.character'], trigger: 'blur'}

      ],
      departName: [
        {required: false},
        {min: 2, max: 100, message: this.language['common.lengthRange']+' 2 '+this.language['common.to']+' 100 '+this.language['common.character'], trigger: 'blur'}

      ],
      siteCode: [
        {required: false, message:this.language['column.pleaseChoose']+this.language['portal.front.factory']+"!"}
      ],
         realname: [
           {required: false, message:this.language['ad.must']+this.language['portal.front.realname']+"!"},
         ],
         phone: [
           /!*{required: true, message: this.language['ad.must']+this.language['column.cellphoneNumber']+"!"},*!/
           {validator: this.validatePhone}
         ],
         captcha: [
           {required: true, message: this.language['ad.must']+this.language['portal.front.verificationCode']+"!"}
         ],
         email: [
           {required: true, message: this.language['ad.must']+this.language['column.mailbox']+"!"},
           {validator: this.validateEmail}
         ]*/
    }}}
  },
  methods: {
    ...mapActions(['Login','PhoneLogin']),
    edit (record) {
      this.model = Object.assign({}, record);
      this.visible = true;
      if(record.userType=="employee"){
        this.initEmpInfo(record.workNo);
        this.userType="employee";
        this.deliveryCompanyName = record.deliveryCompanyName;
      }else{
        this.initUserInfo(record.username);
        this.userType="nonemployee";
      }
    },
    initEmpInfo(workNo) {
      getAction('/sys/employee/queryByWorkNo', {"workNo": workNo}).then((res) => {
        if (res.success) {
         // console.log("==========getUserAndEmpByUserId===========:",res.result);
          this.model = res.result;
        } else {
          console.log(res.message);
        }
      });
    },
    initUserInfo(username) {
      getAction('/sys/user/queryByUserName', {"userName": username}).then((res) => {
        if (res.success) {
          // console.log("==========getUserAndEmpByUserId===========:",res.result);
          this.model = res.result;
        } else {
          console.log(res.message);
        }
      });
    },
    validateEmail(rule, value, callback) {
      let that = this;
      if (!value) {
        callback()
      } else {
        if (new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value)) {
          // let params = {
          //   email: value,
          //   notEqualWorkNo:this.model.workNo
          // };
          // getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res) => {
          //   if (res.success) {
          //     callback()
          //   } else {
          //     callback(this.language['warning.mailboxExists'])
          //   }
          // })

          //去掉邮箱重复验证
          callback()
        } else {
          callback(this.language['warning.emailFormatIncorrect'])
        }
      }
    },
    validatePhone(rule, value, callback) {
      let that = this;
      if(!value){
        callback()
        return
      }
      if (this.userType == "employee") {
          let params = {
            phone: value,
            notEqualWorkNo:this.model.workNo
          };
          getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res) => {
            if (res.success) {
              callback()
            } else {
              callback(this.language['warning.phoneNumberAlreadyExists'])
            }
          })
      }else{
        let params = {
          phone: value,
          notEqualUsername: this.model.username
        };
        getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(this.language['warning.phoneNumberAlreadyExists'])
          }
        })
      }
    },

    handleSubmit() {
      // this.handleLogin();
      // return;
      this.$refs['form'].validate((success) => {
        if (success == true) {
          let values = this.model;
          if(this.userType==="employee"){
            putAction("/sys/portal/employee/edit", values).then((res) => {
              if (!res.success) {
                this.registerFailed(res.message)
              } else {
                this.$message.success(this.language['operationSuccess']);
                //更新缓存数据
                /*commitUserInfo(res);
                setTimeout(() =>{
                  window.location.reload()
                },400);*/


              }
            })
          }else{
            putAction("/sys/user/editUser", values).then((res) => {
              if (!res.success) {
                this.registerFailed(res.message)
              } else {
                this.$message.success(this.language['operationSuccess']);
                //更新缓存数据
                /*commitUserInfo(res);
                setTimeout(() =>{
                  window.location.reload()
                },400);*/


              }
            })
          }
        }
      })
    },loginSuccessLink(){//登录成功后的跳转到首页
      this.$router.push({name: 'protalRegisterResult', params: {...values}})
      this.closeModel();
    },
    registerFailed(message) {
      this.$notification['error']({
        message: this.language['portal.front.register.failed'],
        description: message,
        duration: 2,
      });

    },
    requestFailed(err) {
      this.$notification['error']({
        message: this.language['portal.front.errors'],
        description: ((err.response || {}).data || {}).message || this.language['system.loginPageMessage04'],
        duration: 4,
      });
      this.registerBtn = false;
    }, getCaptcha(e) {
      e.preventDefault();
      const that = this
      that.$refs['form'].validateField('phone', err => {
        if (!err) {
          that.state.smsSendBtn = true;
          let interval = window.setInterval(() => {
            if (that.state.time-- <= 0) {
              that.state.time = 60;
              that.state.smsSendBtn = false;
              window.clearInterval(interval);
            }
          }, 1000);
          const hide = that.$message.loading(this.language['portal.front.code.sending']+'..', 0);
          let smsParams = {
            mobile: that.model.phone,
            smsmode: "1"
          };
          postAction("/sys/portal/sms", smsParams).then(res => {
            if (!res.success) {
              setTimeout(hide, 1);
              that.cmsFailed(res.message);
            }
            setTimeout(hide, 500);
          })
        } else {
          that.cmsFailed(err);
        }
      })
    }, cmsFailed(err) {
      this.$notification['error']({
        message: this.language['portal.front.verificationCode']+this.language['portal.front.errors'],
        description: err,
        duration: 4,
      });
    }, closeModel() {
      this.fatcherMethod();
    }, autoLogin(){
     // alert(this.model.userType);
      if(this.model.userType=='employee'){
        this.handleLogin();
      }else{
        this.handlePhoneLogin();
      }

    }
    ,  //账号密码登录
    handleLogin() {
      let loginParams = {
        username: this.model.username,
        password: this.model.password,
      }
      //console.log("登录参数", loginParams)
      this.Login(loginParams).then((res) => {
       // this.$emit('success', res.result)
        console.log("登录成功回调~"+res);
        //this.loginSuccessLink();
        this.$message.success(this.language['portal.front.auto.login.message']+"！");
        //需要延迟一会才刷新页面，不然提示语出不来
        gotoIndex();
      }).catch((err) => {
        this.$emit('fail', err)
      });
    },handlePhoneLogin(){//手机号码登录
      let loginParams = {
        mobile: this.model.phone,
        captcha: this.model.captcha,
      }
      //console.log("登录参数", loginParams)
      this.PhoneLogin(loginParams).then((res) => {
        this.$message.success(this.language['portal.front.auto.login.message']+"！");
        gotoIndex();
      }).catch((err) => {
        this.$emit('fail', err)
      });
    }
  }, watch: {
    'state.passwordLevel'(val) {
      console.log(val)

    }
  }
}
</script>
<style lang="less">
.user-register {

  &.error {
    color: #ff0000;
  }

  &.warning {
    color: #ff7e05;
  }

  &.success {
    color: #52c41a;
  }

}

.user-layout-register {
  /*background-color: #ffffff;*/
  /*padding: 20px;*/
  .ant-input-group-addon:first-child {
    background-color: #fff;
  }
}
</style>
<style lang="less" scoped>
button.cannel-button {
  padding: 0 15px;
  font-size: 16px;
  height: 40px;
  width: 100px;
  background-color: #bfbfbf;
  border-color: #bfbfbf;
}
button.login-button {
  padding: 0 15px;
  font-size: 16px;
  height: 40px;
  width: 150px;
  margin-left: 20px;
}


.user-layout-register {

  & > h3 {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .register-button {
    width: 50%;
    margin-top: 20px;
  }

  .login {
    float: right;
    line-height: 40px;
    margin-top: 20px;
  }
}

.main{
  min-width: 260px!important;
  width: 500px!important;
}

#userLayout.user-layout-wrapper .container .main {
  min-width: 260px!important;
  width: 500px!important;
  margin: 0 auto;
}
.user-layout-wrapper {
  &.mobile {
    .container {
      .main {
        max-width: 500px;
        width: 98%;
      }
    }
  }
}
.ant-form-item {
  margin-bottom: 15px !important;
}
</style>